

































import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FETCH_BANK_ACCOUNTS, GET_BANK_ACCOUNTS } from '../store/bankAccount';
import { BankAccount, ListOfAssets } from '../types';
import { ApiResponse } from '@/components/types';
import CardRow from '@/components/CardRow.vue';
import BankAccountCard from '@/modules/listOfAssets/components/BankAccountCard.vue';

const BankAccount = namespace('listOfAssets/bankAccount');

@Component({ components: { BankAccountCard, CardRow } })
export default class BankAccountsPlugin extends Vue {
  @Prop({ type: Object, required: true }) listOfAssets!: ListOfAssets;
  @Prop({ type: String, default: 'finance' }) referer!: string;
  @Prop({ type: Boolean, default: false }) showExport!: boolean;

  @BankAccount.Getter(GET_BANK_ACCOUNTS) findByListOfAssets!: (listOfAssetsId: string) => BankAccount[];
  @BankAccount.Action(FETCH_BANK_ACCOUNTS) fetch!: (listOfAssetsId: string) => Promise<ApiResponse<BankAccount[]>>;

  loading: boolean = false;
  showClosed: boolean = false;

  get bankAccounts(): BankAccount[] {
    const weight: { [type: string]: number } = { giro_account: 0, savings_account: 1, building_loan_contract: 2 };

    return this.findByListOfAssets(this.listOfAssets.id)
      .filter((account) => {
        if (this.showClosed) {
          return true;
        }

        return account.state === 'open';
      })
      .sort((first, second) => {
        return weight[first.type] - weight[second.type];
      });
  }

  created() {
    return this.fetch(this.listOfAssets.id);
  }
}
